module.exports = __webpack_public_path__ + "static/media/new-aboutus.f7f0864d.png";